import type { RouteRecordRaw } from 'vue-router';

// S1/S2 staff checkout routes per ADR-007: admin|staff. lifecycle gate =
// closed — the staff-checkout window opens at close and never shuts, since
// closed is the auction's terminal status (GT1-459).
export const routes: RouteRecordRaw[] = [
  {
    path: '/staff/auctions/:id/checkout',
    name: 'staff-checkout',
    component: () => import('./pages/StaffConsolePage.vue'),
    meta: {
      requiresAdminAuth: true,
      requiredRole: 'any',
      lifecycle: ['closed'],
    },
  },
];
